export const parseCtaAction = (entry) => ({
  ctaAction: entry?.['cta-action'] ?? null,
  ctaInternal: entry?.['cta-internal'] ?? null,
  ctaExternal: entry?.['cta-external'] ?? null,
});
